// roles.js
export const STUDENT = '学生'
export const TEACHER = '教师'
export const ADMIN = '管理员'
// ... 其他角色
